import * as React from 'react';
import { createVideoUrl } from '../../../cloudinary';
import styled from '../../../styled-components';

export interface HiringManagerVideoProps {
    videoReference: string | null;
}

const Wrapper = styled.div`
    grid-area: video;
`;

const HiringManagerVideo: React.FC<HiringManagerVideoProps> = props => (
    <Wrapper>
        {props.videoReference && <h2>Hiring manager's video</h2>}
        {props.videoReference && (
            <video controls={true} autoPlay={false} style={{ width: '100%' }}>
                <source src={createVideoUrl(props.videoReference)} type="video/mp4" />
            </video>
        )}
    </Wrapper>
);

export default HiringManagerVideo;



// WEBPACK FOOTER //
// ./src/scenes/vacancy/components/HiringManagerVideo.tsx